import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const subscribeEmail = (payload) => api.post("/subscribe", payload).then((r) => r.data);

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const fetchArticles = (category) =>
    api.get("/articles", { params: category ? { category } : {} }).then((r) => r.data);

export const fetchArticle = (slug) => api.get(`/articles/${slug}`).then((r) => r.data);
